module.exports = __webpack_public_path__ + "img/trash-red.296c5380.svg";